
import React, { ReactNode } from 'react';
import { CQAppStore } from '../../store/cq-app-store';
import actionSprite from './svg-icon-collection/action-sprite.svg';
import customSprite from './svg-icon-collection/custom-sprite.svg';
import doctypeSprite from './svg-icon-collection/doctype-sprite.svg';
import standardSprite from './svg-icon-collection/standard-sprite.svg';
import utilityType from './svg-icon-collection/utility-sprite.svg';
import IconPickerController from './icon-picker.controller';
import './icon-picker.css';

interface IICONPickerProps {
    name: string;
    value: string;
    onChange?: any;
    updateIconName: (iconClassName: string) => void;
}

interface IICONPickerState{
    isIconPicker: boolean;
    selectedIconClassName: string;
    selectIconCategory: string;
    groupWiseIconList: {
        actionSpriteIcons: string[];
        customSpriteIcons: string[];
        doctypeSpriteIcons: string[];
        standardSpriteIcons: string[];
        utilityTypeIcons: string[];
    }
}

export default class IconPicker extends React.Component<IICONPickerProps,IICONPickerState> {

    private readonly iconPickerCtrl: IconPickerController;
    constructor(props: Readonly<IICONPickerProps>) {
        super(props);
        this.iconPickerCtrl = new IconPickerController();
        this.state = {
            isIconPicker: false,
            selectedIconClassName: '',
            selectIconCategory: 'action',
            groupWiseIconList: { actionSpriteIcons: [], customSpriteIcons: [], doctypeSpriteIcons: [], standardSpriteIcons: [], utilityTypeIcons: [] }
        };
    }

    clearIconSelection = () => {
        this.props.updateIconName(``);   
    }

    toggleIconPickerVisibility = () => {
        this.setState({ isIconPicker: !this.state.isIconPicker });
    }

    setIconName = (iconName: string) => {
        this.props.updateIconName(`${this.state.selectIconCategory}:${iconName}`);
        this.setState({ isIconPicker: false });
    }

    setSelectedCategory = (category: string) => {
        
        this.setState({ selectIconCategory: category });
    }

    async componentDidMount() {
        try {
            const iconGroupsList = [actionSprite, customSprite, doctypeSprite, standardSprite, utilityType];
            const groupWiseIconList: any = await this.iconPickerCtrl.getGroupWiseIconList(iconGroupsList);
            this.setState({ groupWiseIconList });
        }
        catch (error) {
            CQAppStore.loader.setVisibility(false);
        }
    }

    public render(): ReactNode {
        const { onChange, value, name} = this.props;
        return (
            <>
                <div className="slds-combobox__form-element slds-input-has-icon slds-input-has-icon_right">
                    <input type="text" id="text-input-id-1" placeholder=""
                        className="slds-input slds-combobox__input slds-combobox__input-value"
                        autoComplete="off"
                        name={name}
                        value={value}
                        onChange={onChange}
                        onFocus={this.toggleIconPickerVisibility}
                        role="inputIcon"
                    />
                    {
                        value &&
                        <button className="slds-button slds-button_icon slds-input__icon slds-input__icon_right" title="Remove selected icon">
                            <i className="cq-icon-close" role="removeIcon" onClick={() => this.clearIconSelection()}></i>
                            <span className="slds-assistive-text">Remove selected icon</span>
                        </button>
                    }
                </div>
                {
                    this.state.isIconPicker &&
                    <>
                        <section role="dialog" className="slds-modal slds-fade-in-open slds-modal_small">
                            <div className="slds-modal__container">
                                <header className="slds-modal__header">
                                    <button className="slds-button slds-button_icon slds-modal__close slds-button_icon-inverse"
                                        onClick={() => this.toggleIconPickerVisibility()} title="Close">
                                        <i className="cq-icon-close"></i>
                                    </button>
                                    <h2 id="modal-heading-01" className="slds-modal__title slds-hyphenate">Select Icon</h2>
                                </header>
                                <div className="slds-modal__content slds-p-around_medium" id="modal-content-id-1">
                                    <div className="slds-tabs_default slds-grid slds-grid_vertical full-height">
                                        <ul className="slds-tabs_default__nav" role="tablist">
                                            <li className={`slds-tabs_default__item ${this.state.selectIconCategory === 'action' ? 'slds-is-active' : ''}`}
                                                onClick={() => this.setSelectedCategory('action')}
                                                role="presentation">
                                                <a className="slds-tabs_default__link" aria-controls="tab-default-1" id="tab-default-1__item">Action</a>
                                            </li>
                                            <li className={`slds-tabs_default__item ${this.state.selectIconCategory === 'custom' ? 'slds-is-active' : ''}`}
                                                role="presentation"
                                                onClick={() => this.setSelectedCategory('custom')}>
                                                <a className="slds-tabs_default__link" aria-controls="tab-default-2" id="tab-default-2__item">Custom</a>
                                            </li>
                                            <li className={`slds-tabs_default__item ${this.state.selectIconCategory === 'doctype' ? 'slds-is-active' : ''}`}
                                                role="presentation"
                                                onClick={() => this.setSelectedCategory('doctype')}>
                                                <a className="slds-tabs_default__link" aria-controls="tab-default-3" id="tab-default-3__item">Doctype</a>
                                            </li>
                                            <li className={`slds-tabs_default__item ${this.state.selectIconCategory === 'standard' ? 'slds-is-active' : ''}`}
                                                role="presentation"
                                                onClick={() => this.setSelectedCategory('standard')}>
                                                <a className="slds-tabs_default__link" aria-controls="tab-default-4" id="tab-default-4__item">Standard</a>
                                            </li>
                                            <li className={`slds-tabs_default__item ${this.state.selectIconCategory === 'utility' ? 'slds-is-active' : ''}`}
                                                role="presentation"
                                                onClick={() => this.setSelectedCategory('utility')}>
                                                <a className="slds-tabs_default__link" aria-controls="tab-default-5" id="tab-default-5__item">Utility</a>
                                            </li>
                                        </ul>
                                        {
                                            this.state.selectIconCategory === 'action' &&
                                            <div id="tab-default-1" className="slds-tabs_default__content slds-show scroll-content"
                                                role="tabpanel" aria-labelledby="tab-default-1__item">
                                                <ul className="icons-wrapper slds-grid slds-wrap">
                                                    {
                                                        this.state.groupWiseIconList && this.state.groupWiseIconList.actionSpriteIcons &&
                                                        this.state.groupWiseIconList.actionSpriteIcons.map((iconName: string, actionIndex: number) => {
                                                            const iconClassName = iconName.replace(new RegExp('_', 'g'), '-');
                                                            return (
                                                                <li key={actionIndex} className="site-icon-width-container slds-m-bottom_x-large">
                                                                    <figure className="slds-text-align_center"
                                                                        onClick={() => this.setIconName(iconName)}>
                                                                        <span className={`slds-icon_container slds-icon-action-${iconClassName} 
                                                                        slds-icon_container--circle`}>
                                                                            <img src={`/assets/icons/action/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                                                                        </span>
                                                                        <figcaption className="slds-p-top-x-small slds-text-body_small">{iconName}</figcaption>
                                                                    </figure>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        {
                                            this.state.selectIconCategory === 'custom' &&
                                            <div id="tab-default-1" className="slds-tabs_default__content slds-show scroll-content"
                                                role="tabpanel" aria-labelledby="tab-default-1__item">
                                                <ul className="icons-wrapper slds-grid slds-wrap">
                                                    {
                                                        this.state.groupWiseIconList && this.state.groupWiseIconList.customSpriteIcons &&
                                                        this.state.groupWiseIconList.customSpriteIcons.map((iconName: string, customIndex: number) => {
                                                            const iconClassName = iconName.replace(new RegExp('_', 'g'), '-');
                                                            return (
                                                                <li key={customIndex} className="site-icon-width-container slds-m-bottom_x-large">
                                                                    <figure className="slds-text-align_center"
                                                                        onClick={() => this.setIconName(iconName)}>
                                                                        <span className={`slds-icon_container  slds-icon-custom-${iconClassName}  slds-icon_container--circle`}>
                                                                            <img src={`/assets/icons//custom/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                                                                        </span>
                                                                        <figcaption className="slds-p-top-x-small slds-text-body_small">{iconName}</figcaption>
                                                                    </figure>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        {
                                            this.state.selectIconCategory === 'doctype' &&
                                            <div id="tab-default-1" className="slds-tabs_default__content slds-show scroll-content"
                                                role="tabpanel" aria-labelledby="tab-default-1__item">
                                                <ul className="icons-wrapper slds-grid slds-wrap">
                                                    {
                                                        this.state.groupWiseIconList && this.state.groupWiseIconList.doctypeSpriteIcons &&
                                                        this.state.groupWiseIconList.doctypeSpriteIcons.map((iconName: string, doctypeIndex: number) => {
                                                            const iconClassName = iconName.replace(new RegExp('_', 'g'), '-');
                                                            return (
                                                                <li key={doctypeIndex} className="site-icon-width-container slds-m-bottom_x-large">
                                                                    <figure className="slds-text-align_center"
                                                                        onClick={() => this.setIconName(iconName)}>
                                                                        <span className={`slds-icon_container slds-icon-doctype-${iconClassName} slds-icon_container--circle`}>
                                                                            <img src={`/assets/icons//doctype/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                                                                        </span>
                                                                        <figcaption className="slds-p-top-x-small slds-text-body_small">{iconName}</figcaption>
                                                                    </figure>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        {
                                            this.state.selectIconCategory === 'standard' &&
                                            <div id="tab-default-1" className="slds-tabs_default__content slds-show scroll-content"
                                                role="tabpanel" aria-labelledby="tab-default-1__item">
                                                <ul className="icons-wrapper slds-grid slds-wrap">
                                                    {
                                                        this.state.groupWiseIconList && this.state.groupWiseIconList.standardSpriteIcons &&
                                                        this.state.groupWiseIconList.standardSpriteIcons.map((iconName: string, standardIndex: number) => {
                                                            const iconClassName = iconName.replace(new RegExp('_', 'g'), '-');
                                                            return (
                                                                <li key={standardIndex} className="site-icon-width-container slds-m-bottom_x-large">
                                                                    <figure className="slds-text-align_center"
                                                                        onClick={() => this.setIconName(iconName)}>
                                                                        <span className={`slds-icon_container slds-icon-standard-${iconClassName} slds-icon_container--circle`}>
                                                                            <img src={`/assets/icons//standard/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                                                                        </span>
                                                                        <figcaption className="slds-p-top-x-small slds-text-body_small">{iconName}</figcaption>
                                                                    </figure>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                        {
                                            this.state.selectIconCategory === 'utility' &&
                                            <div id="tab-default-1" className="slds-tabs_default__content slds-show scroll-content"
                                                role="tabpanel" aria-labelledby="tab-default-1__item">
                                                <ul className="icons-wrapper slds-grid slds-wrap">
                                                    {
                                                        this.state.groupWiseIconList && this.state.groupWiseIconList.utilityTypeIcons &&
                                                        this.state.groupWiseIconList.utilityTypeIcons.map((iconName: string, utilityIndex: number) => {
                                                            return (
                                                                <li key={utilityIndex} className="site-icon-width-container slds-m-bottom_x-large">
                                                                    <figure className="slds-text-align_center"
                                                                        onClick={() => this.setIconName(iconName)}>
                                                                        <span className="slds-icon_container slds-icon-action-add-contact slds-icon_container--circle">
                                                                            <img src={`/assets/icons//utility/${iconName}.svg`} alt={`${iconName}`} className="iconStyle" />
                                                                        </span>
                                                                        <figcaption className="slds-p-top-x-small slds-text-body_small">{iconName}</figcaption>
                                                                    </figure>
                                                                </li>
                                                            );
                                                        })
                                                    }
                                                </ul>
                                            </div>
                                        }
                                    </div>
                                </div>
                                <footer className="slds-modal__footer">
                                    <button className="slds-button slds-button_neutral" onClick={() => this.toggleIconPickerVisibility()}>Cancel</button>
                                </footer>
                            </div>
                        </section>
                        <div className="slds-backdrop slds-backdrop_open"></div>
                    </>
                }
            </>
        );
    }
}

